import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=47d24a4a&scoped=true&"
import script from "./contextMenu.vue?vue&type=script&lang=js&"
export * from "./contextMenu.vue?vue&type=script&lang=js&"
import style0 from "./contextMenu.vue?vue&type=style&index=0&id=47d24a4a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d24a4a",
  null
  
)

export default component.exports